const widgetMaximize = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polygon points="11.8347361 5.34952689 5.34952689 11.8347361 7.51142857 14 2 14 2 8.48 4.16618407 10.6495529 10.6495529 4.16618407 8.48 2 14 2 14 7.51142857"/></svg>',
};

export { widgetMaximize as default };
